import { Platform } from 'react-native';

import { DrawerProps } from './types';

export const Drawer: React.FC<DrawerProps> =
  Platform.OS === 'web'
    ? require('./Drawer.web').Drawer
    : require('./Drawer.native').Drawer;
